import { BookOpen, MessagesSquare, ArrowUpRight, Package } from "lucide-react";

const DISCORD = "https://discord.gg/5BhxH73ay";

const scrollToModules = () => {
  const el = document.getElementById("dashboard-modules");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const DashboardQuickActions = ({ hasModules, onOpenWorkbook }) => (
  <>
    <div className="grid grid-cols-12 gap-4 md:gap-6 mb-6">
      <button onClick={scrollToModules} data-testid="dashboard-library" className="spotlight tacc-card col-span-12 md:col-span-7 p-8 md:p-10 flex flex-col justify-between min-h-[220px] text-left">
        <Package size={28} className="text-[#B45309]" strokeWidth={1.3} />
        <div>
          <div className="section-tag mb-2">Your Library</div>
          <h3 className="font-display text-3xl md:text-4xl tracking-tight mb-2">Preview all 8 modules</h3>
          <p className="text-[#78716C] text-sm max-w-md">
            {hasModules
              ? "Your 8 video modules are unlocked below — press Watch on any module. The Amazon books are further down."
              : "Scroll down to preview every module. Unlock all 8 video modules right here with one card payment — the Amazon books are further down."}
          </p>
        </div>
      </button>
      <a href={DISCORD} target="_blank" rel="noreferrer" data-testid="dashboard-discord" className="spotlight tacc-card col-span-12 md:col-span-5 p-8 md:p-10 flex flex-col justify-between min-h-[220px]">
        <MessagesSquare size={28} className="text-[#B45309]" strokeWidth={1.3} />
        <div>
          <div className="section-tag mb-2">Community</div>
          <h3 className="font-display text-3xl md:text-4xl tracking-tight mb-2">Join the Discord</h3>
          <p className="text-[#78716C] text-sm">Members-only channels, live sessions, and accountability.</p>
        </div>
      </a>
    </div>

    {hasModules && (
      <button onClick={onOpenWorkbook} data-testid="dashboard-my-workbook" className="spotlight tacc-card w-full mt-6 p-6 md:p-7 flex items-center justify-between gap-4 text-left group">
        <div className="flex items-center gap-4">
          <BookOpen size={26} className="text-[#B45309] shrink-0" strokeWidth={1.3} />
          <div>
            <div className="section-tag mb-1">Your Workbook</div>
            <h3 className="font-heading text-lg tracking-tight">Reread everything you&apos;ve written</h3>
            <p className="text-[#78716C] text-sm">All your saved answers across the 8 modules, in one place.</p>
          </div>
        </div>
        <ArrowUpRight size={18} className="text-[#78716C] group-hover:text-[#B45309] transition-colors shrink-0" />
      </button>
    )}
  </>
);
